import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ChartTooltip } from './ChartTooltip';
import { CHART_COLORS, CHART_GRADIENTS } from './chart-tokens';

/**
 * Area chart polido com gradient fill suave embaixo da linha.
 * Substitui o LineChart antigo da seção "Evolução de Investimentos & Despesas".
 */
export function EvolutionAreaChart({
  data,
  margin,
  xAxisInterval,
  minTickGap,
  tickFontSize,
  yAxisWidth,
  tickFormatter,
  formatCurrency,
  investmentsLegend,
  expensesLegend,
}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={margin}>
        <defs>
          <linearGradient id={CHART_GRADIENTS.area.invested.id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_GRADIENTS.area.invested.from} />
            <stop offset="100%" stopColor={CHART_GRADIENTS.area.invested.to} />
          </linearGradient>
          <linearGradient id={CHART_GRADIENTS.area.expense.id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_GRADIENTS.area.expense.from} />
            <stop offset="100%" stopColor={CHART_GRADIENTS.area.expense.to} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
        <XAxis
          dataKey="mes"
          stroke="#94a3b8"
          axisLine={false}
          tickLine={false}
          interval={xAxisInterval}
          minTickGap={minTickGap}
          tick={{ fontSize: tickFontSize, fill: '#64748b' }}
          tickMargin={10}
        />
        <YAxis
          stroke="#94a3b8"
          axisLine={false}
          tickLine={false}
          width={yAxisWidth}
          tick={{ fontSize: tickFontSize, fill: '#64748b' }}
          tickFormatter={tickFormatter}
        />
        <Tooltip
          content={<ChartTooltip formatter={(v) => formatCurrency(v)} />}
          cursor={{ stroke: '#cbd5e1', strokeDasharray: '4 4' }}
        />
        <Legend
          iconType="circle"
          wrapperStyle={{ fontSize: `${tickFontSize}px`, paddingTop: 12 }}
        />
        <Area
          type="monotone"
          dataKey="investido"
          name={investmentsLegend}
          stroke={CHART_COLORS.invested.base}
          strokeWidth={2.5}
          fill={`url(#${CHART_GRADIENTS.area.invested.id})`}
          isAnimationActive
          animationDuration={1100}
          animationEasing="ease-out"
          activeDot={{
            r: 6,
            fill: CHART_COLORS.invested.base,
            stroke: '#fff',
            strokeWidth: 2,
          }}
        />
        <Area
          type="monotone"
          dataKey="despesas"
          name={expensesLegend}
          stroke={CHART_COLORS.expense.base}
          strokeWidth={2.5}
          fill={`url(#${CHART_GRADIENTS.area.expense.id})`}
          isAnimationActive
          animationDuration={1100}
          animationBegin={200}
          animationEasing="ease-out"
          activeDot={{
            r: 6,
            fill: CHART_COLORS.expense.base,
            stroke: '#fff',
            strokeWidth: 2,
          }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default EvolutionAreaChart;
